
import { Mail } from "lucide-react";

interface NewsletterFormHeaderProps {
  standalone?: boolean;
  isModal?: boolean;
}

export function NewsletterFormHeader({ standalone = false, isModal = false }: NewsletterFormHeaderProps) {
  if (!standalone && !isModal) return null;
  
  return (
    <div className="text-center mb-6">
      <div className="flex justify-center mb-3">
        <Mail className={`h-8 w-8 ${isModal ? "text-[#00123A]" : "text-[#00123A]"}`} />
      </div>
      <h2 className={`text-2xl font-bold mb-2 ${isModal ? "text-[#00123A]" : "text-[#00123A]"}`}>
        {isModal ? "Inscription à la newsletter" : "Restez informés"}
      </h2>
      {!isModal && (
        <p className="text-[#00123A]">
          Recevez nos actualités et participez à nos événements exclusifs.
        </p>
      )}
    </div>
  );
}
